/**
 * Chat backend identifiers — isomorphic (safe to import from client
 * components; no server-only dependencies). Backend *resolution* lives in
 * ./chat-backend (server-only: reads env, logs via server-log).
 */
export const RAILS_BACKEND = 'rails' as const;
export const SOR_BACKEND = 'sor' as const;
export type ChatBackend = typeof RAILS_BACKEND | typeof SOR_BACKEND;
